import { Directive } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms';

// Supported video URLs
const BASE = /(http(s)?:\/\/)?(m\.|www\.)?/;

const YOUTUBE_URL =
  /(youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?/;
const VIMEO_URL =
  /vimeo\.com\/(?:\w+\/\w+\/video\/|album\/\w+\/video\/|channels\/\w+\/|groups\/\w+\/videos\/)?\d+/;

const VIDEO_URLS = new RegExp(
  `^${BASE.source}(${YOUTUBE_URL.source}|${VIMEO_URL.source})$`,
  'ig'
);

export function isValidVideoUrl(url: string): boolean {
  return !!url.match(VIDEO_URLS);
}

export function validateVideoUrl(
  control: AbstractControl
): ValidationErrors | null {
  return !control.value || isValidVideoUrl(control.value)
    ? null
    : { videoUrl: 'Invalid video URL' };
}

@Directive({
  selector: '[elmValidateVideoUrl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ElmValidateVideoUrlDirective,
      multi: true
    }
  ]
})
export class ElmValidateVideoUrlDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return validateVideoUrl(control);
  }
}
